import { actionTypes } from "../LeadPonds/actions/actionTypes";

const defaultState = {
  isModalOpen: false,
  alerts: false,
  isAdmin: false,
  leadPondsCollection: [],
  usersCollection: [],
  pageSize: 40,
  totalPages: 0,
  isSaving: false,
  hasSaveError: false,
  isLoadingMore: false,
  hasLoadingMoreError: false,
  isCheckingDuplicate: false,
  page: 1,
  pondData: null,
  errors: "",
  leadPondsNotificationsOn: false,
  maximumPondsReached: false,
};

const leadPondsReducer = (state = defaultState, payload) => {
  switch (payload.type) {
    case actionTypes.openPondModal:
      return {
        ...state,
        isModalOpen: true,
        pondData: payload.pond,
      };
    case actionTypes.closePondModal:
      return {
        ...state,
        isModalOpen: false,
        hasDuplicate: false,
        pondData: null,
        hasError: false,
        errorMessage: undefined,
      };

    case actionTypes.showAlert:
      return {
        ...state,
        alert: payload,
        errors: null,
      };
    case actionTypes.hideAlert:
      return {
        ...state,
        alert: false,
      };

    case actionTypes.createPond:
      return {
        ...state,
        isSaving: true,
        hasSaveError: false,
      };
    case actionTypes.createPondSuccess:
      return {
        ...state,
        isSaving: false,
        leadPondsCollection: [...state.leadPondsCollection, payload.leadPond],
        hasSaveError: false,
      };
    case actionTypes.createPondError:
      return {
        ...state,
        isSaving: false,
        hasSaveError: true,
      };

    case actionTypes.updatePond:
      return {
        ...state,
        isSaving: true,
        hasSaveError: false,
      };
    case actionTypes.updatePondSuccess:
      // update the passed back model
      return {
        ...state,
        leadPondsCollection: [...state.leadPondsCollection].map((lp) => {
          if (lp.id === payload.leadPond.id) {
            return payload.leadPond;
          }
          return lp;
        }),
        isSaving: false,
        hasSaveError: false,
      };
    case actionTypes.updatePondError:
      return {
        ...state,
        isSaving: false,
        hasSaveError: true,
      };

    case actionTypes.removePond:
      return {
        ...state,
        hasSaveError: false,
      };
    case actionTypes.removePondSuccess:
      // update the passed back model
      return {
        ...state,
        leadPondsCollection: [...state.leadPondsCollection].filter((lp) => lp.id !== payload.id),
        hasSaveError: false,
      };
    case actionTypes.removePondError:
      return {
        ...state,
        hasSaveError: true,
      };

    case actionTypes.loadMorePonds:
      return {
        ...state,
        isLoadingMore: true,
        hasLoadingMoreError: false,
      };
    case actionTypes.loadMorePondsSuccess:
      return {
        ...state,
        page: state.page + 1, // increment to the next page
        isLoadingMore: false,
        leadPondsCollection: [...state.leadPondsCollection, ...payload.page],
        totalPages: payload.total_pages,
      };
    case actionTypes.loadMorePondsError:
      return {
        ...state,
        isLoadingMore: false,
        hasLoadingMoreError: true,
      };

    case actionTypes.getAssignableUsers:
      return {
        ...state,
        isLoadingUsers: true,
        hasLoadingUsersError: false,
      };
    case actionTypes.getAssignableUsersSuccess:
      return {
        ...state,
        isLoadingUsers: false,
        hasLoadingUsersError: false,
        usersCollection: [...payload.users],
      };
    case actionTypes.getAssignableUsersError:
      return {
        ...state,
        isLoadingUsers: false,
        hasLoadingUsersError: true,
      };
    case actionTypes.duplicateCheck:
      return {
        ...state,
        isCheckingDuplicate: true,
        hasDuplicate: false,
        duplicateError: false,
      };
    case actionTypes.duplicateCheckClear:
      return {
        ...state,
        isCheckingDuplicate: false,
        hasDuplicate: false,
        duplicateError: false,
      };
    case actionTypes.duplicateCheckSuccess:
      return {
        ...state,
        isCheckingDuplicate: false,
        hasDuplicate: (() => {
          // check if this is the pond were editing or if it's new
          const fnd = state.pondData ? payload.results.filter((r) => r.id === state.pondData.id) : [];
          const dup = payload.results.length > 0 && fnd.length === 0; // we ignore duplicates if its the same pond were editing
          return dup;
        })(),
        duplicateError: false,
      };
    case actionTypes.duplicateCheckError:
      return {
        ...state,
        isCheckingDuplicate: false,
        hasDuplicate: false,
        duplicateError: true,
      };

    default:
      return state;
  }
};

export default leadPondsReducer;
